import Vue from "vue";
import Vuex from "vuex";
import { getAll } from "@/api/seting";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    getAll() {
      getAll().then((res) => {
        if (res.status) {
          localStorage.setItem("title", res.data.weChatWebName);
        }
      });
    },
  },
  modules: {},
});
